module.exports = __webpack_public_path__ + "static/img/3.29214c92.png";